const REQUEST = `REQUEST`
const SUCCESS = `SUCCESS`
const ERROR = `ERROR`
const SET_CURRENT = `SET_CURRENT`
const NEXT_PAGE = `NEXT_PAGE`
const PREV_PAGE = `PREV_PAGE`
const RSET_PAGE = `RSET_PAGE`
const ROOT = { root: true }

export {
  REQUEST,
  SUCCESS,
  ERROR,
  PREV_PAGE,
  NEXT_PAGE,
  RSET_PAGE,
  SET_CURRENT,
  ROOT,
}
